// src/payment/core/PaymentService.js
import axios from 'axios';
import API from '../../api/config/api.config';
import ENV from '../../api/config/env.config';

export class PaymentService {
  constructor(slug, resumen) {
    this.slug = slug;
    this.resumen = resumen;
    this.transactionId = Date.now();
  }

  // ==========================================
  // REGISTRO DE DATOS (COMPARTIDO)
  // ==========================================
  async registerFormData(paymentMethod, qrId = null, paymentIntentId = null) {
    try {
      const payload = {
        slug: this.slug,
        id_qr: qrId,
        payment_intent_id: paymentIntentId,
        paqueteSeleccionado: this.resumen.paqueteSeleccionado || null,
        id_package: this.resumen.paqueteSeleccionado?.id_package || this.resumen.paqueteSeleccionado?.id || null,
        description: this.resumen.paqueteSeleccionado?.description || 'Sin descripción',
        // 🟢 FIX: se prioriza `montoConFee` (precio base + fee, calculado en
        // PaymentModal) sobre `monto` (precio base puro). `monto` debe
        // seguir siendo la base pura porque así lo valida el backend al
        // crear el QR/PaymentIntent (ver adminStripeConfigController.js /
        // bnbController.js) — pero para EL REGISTRO FINAL (lo que se graba
        // en la tabla de competidores y lo que se muestra en el correo de
        // confirmación, ver formController.js línea ~971), lo correcto es
        // guardar el total REAL que se le cobró al usuario, fee incluido.
        monto: this.resumen.montoConFee ?? this.resumen.monto ?? 0,
        transactionId: this.transactionId,
        paymentMethod,
        camposActivos: this.resumen.camposActivos?.map(campo => ({
          nombre: campo.nombre,
          valor: campo.valor
        })) || [],
      };

      

      const response = await axios.post(
        `${ENV.API.BASE_URL}${API.REGISTRATION.FORM_DATA}`,
        payload
        // 🔒 Sin Authorization: este endpoint lo usa el competidor, sin sesión.
      );

      return response.data;
    } catch (error) {
      console.error('[PaymentService] Error en registro:', error);
      throw PaymentService._handleError(error);
    }
  }

  // ==========================================
  // VERIFICACIÓN DE MÉTODOS DE PAGO (ESTÁTICO, PÚBLICO)
  // ==========================================
  static async getAvailablePaymentMethods(slug) {
    try {
      const [bankResponse, stripeResponse] = await Promise.allSettled([
        axios.get(`${ENV.API.BASE_URL}${API.BANK.PUBLIC_AVAILABILITY}/${slug}`),
        axios.get(`${ENV.API.BASE_URL}${API.STRIPE.CONFIG}/${slug}`),
      ]);
  
      return {
        qr:
          bankResponse.status === 'fulfilled'
            ? bankResponse.value.data?.is_enabled ?? true
            : true,
  
        stripe:
          stripeResponse.status === 'fulfilled'
            ? stripeResponse.value.data?.is_enabled ?? false
            : false,
  
        loading: false,
      };
    } catch (error) {
      console.error('[PaymentService] Error al obtener métodos:', error);
  
      return {
        qr: true,
        stripe: false,
        loading: false,
        error: 'Error al cargar métodos de pago',
      };
    }
  }

  // ==========================================
  // HELPERS ESTÁTICOS
  // ==========================================
  // Solo se usa para llamadas que sí requieren sesión de admin (si las hubiera
  // en este servicio). Nunca manda "Bearer null": si no hay token, no manda header.
  static _getHeaders() {
    const token = localStorage.getItem('token');
    return {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      'Content-Type': 'application/json',
    };
  }

  static _handleError(error) {
    if (error.response) {
      return new Error(`[${error.response.status}] ${error.response.data?.message || error.message}`);
    }
    if (error.request) {
      return new Error('No se pudo conectar con el servidor');
    }
    return error;
  }
}
